import axios from "axios";

export default axios.create({
  baseURL: `https://api-${window.location.host}`,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json"
  }
});

export const CarrierxAPI = axios.create({
  baseURL: "https://api.carrierx.com/core/v2/",
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
    "Authorization": "Bearer 2008c747-6dfe-4cef-a22d-c1116bd435ce"
  }
});
